import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser, enumParser, PartnerOrganizationBillingModel, PartnerOrganizationStatus, PartnerOrganizationTier, PartnerOrganizationType, } from '#validation';
export const PartnerOrganizationResponseSchema = z.object({
    id: z.string(),
    name: z.string(),
    type: enumParser(PartnerOrganizationType),
    status: enumParser(PartnerOrganizationStatus),
    parentOrganizationId: z.string().nullable(),
    accountOwnerAccountId: z.uuid().nullable(),
    tier: enumParser(PartnerOrganizationTier).nullable(),
    supportedBillingModels: z.array(enumParser(PartnerOrganizationBillingModel)),
    contractId: z.string().nullable(),
    renewalDate: dateParser().nullable(),
    notes: z.string().nullable(),
    isDemo: z.boolean(),
    owner: z.object({
        email: z.email().nullish(),
    }),
});
export class PartnerOrganizationResponseDto extends createZodDto(PartnerOrganizationResponseSchema) {
}
